import React from "react";
import moment from "moment";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button } from "aible";

import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as recipeReducer from "containers/Recipe/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import { getProjectID, getProjectDatasets, getCreatingProject } from "containers/ConsultingProjects/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { getIsDataLink } from "containers/SchemaMonitor/reducer";

import DatasetItem from "containers/View/Item/DatasetItem";
import RecipeItem from "containers/View/Item/RecipeItem";

import EmptyTile from "components/Tiles/EmptyTile";
import EmptyNotice from "components/View/EmptyNotice";

import Sense from "components/Next/Google/GoogleSheetsSense";
import ViewMessage from "components/View/ViewMessage";

import * as schemaMonitorReducer from "containers/SchemaMonitor/reducer";

import { isEnabled } from "utils/featureFlags";

class SenseViewContainer extends React.Component {
  state = {
    showUploadModal: false,
    isLinkMode: false,
    uploadUrl: undefined
  };

  setModal(value = false) {
    return this.setState({
      showUploadModal: value,
      uploadUrl: undefined,
      shellDatasetName: undefined,
      shellDatasetDescription: undefined
    });
  }

  handleFile(event) {
    const { handleFileChange, validateFileExtension } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      this.setModal(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  createShellDataset(name) {
    const { handleFileChange } = this.props;

    // create dummy file - not actually uploaded
    const blob = new Blob(["1"], { type: "text/plain" });
    const file = new File([blob], name, { type: blob.type });

    this.setState({ uploadUrl: "Creating..." });

    return handleFileChange(
      file,
      {},
      {
        skipUpload: true,
        description: this.state.shellDatasetDescription
      }
    ).then((dataset) => this.setState({ uploadUrl: dataset.metadata.upload_url }));
  }

  handleImportRecipeTrigger() {
    const { importRecipeId, executeRecipeImport, linkBlueprintToRecipeVersionInstance } = this.props;
    this.setState({
      isImportRecipeCreating: true
    });

    executeRecipeImport(importRecipeId, () => {
      this.setState({ isImportRecipeCreating: false });
    }).then((recipeVersionInstance) => linkBlueprintToRecipeVersionInstance(recipeVersionInstance.id));
  }

  render() {
    const { data, selectedAccountId } = this.props;

    const { showUploadModal } = this.state;

    return (
      <React.Fragment>
        <Sense
          {...this.props}
          datasets={data}
          uploadCSV={() => this.setModal(true)}
          handleClick={(dataset) => console.log("dclick", dataset)}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  handleFileChange: (file, target, additionalOptions) =>
    dispatch(uploadReducer.handleFileChange(file, target, additionalOptions)),

  handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),
  executeRecipeImport: (recipeId, onComplete) => dispatch(recipeReducer.executeRecipeImport(recipeId, onComplete)),

  fetchNext: () => dispatch(homeReducer.fetchNextDatasets()),
  fetchAll: () => dispatch(homeReducer.fetchNextDatasets(true)),
  fetchDatasetWithoutDetails: (datasetId) => dispatch(homeReducer.fetchDatasetWithoutDetails(datasetId)),
  linkBlueprintToRecipeVersionInstance: (recipeVersionInstanceId) =>
    dispatch(recipeReducer.linkBlueprintToRecipeVersionInstance(ownProps.blueprintId, recipeVersionInstanceId)),

  handleDelete: (datasetId) => dispatch(homeReducer.deleteDataset(datasetId)),

  updateIsSchemaLinkMode: (show) => dispatch(schemaMonitorReducer.updateIsShowModal(show)),
  updateIsLinkMode: (show) => dispatch(viewReducer.updateIsLinkMode(show)),
  updateIsBoomiLinkMode: (show) => dispatch(viewReducer.updateIsBoomiLinkMode(show)),
  linkDataset: (settings) => dispatch(homeReducer.linkDataset(settings)),
  changeDatasetTarget: (datasetId, target) => dispatch(homeReducer.changeDatasetTarget(datasetId, target)),
  setDatasetTarget: (datasetId, target, success) => dispatch(homeReducer.setDatasetTarget(datasetId, target, success)),

  updateTerminalConditions: (datasetId, terminalConditions) =>
    dispatch(projectReducer.updateTerminalConditions(datasetId, terminalConditions)),

  updateIgnored: (datasetId, column, isIgnored) => dispatch(setupReducer.updateIgnored(datasetId, column, isIgnored)),

  copyTransformFromSetup: (datasetId, jobId) => dispatch(homeReducer.copyTransformFromSetup(datasetId, jobId)),

  openExploration: (datasetId, outcomeValue, comparisonOptions) =>
    dispatch(nextReducer.openExploration(datasetId, outcomeValue, comparisonOptions)),
  openDashboard: (datasetId, outcomeValue) => dispatch(nextReducer.openDashboard(datasetId, outcomeValue)),
  openCreateModels: (datasetId, outcomeValue, comparisonOptions) =>
    dispatch(nextReducer.openCreateModels(datasetId, outcomeValue, comparisonOptions)),
  openDataset: (datasetId, outcomeValue) => dispatch(nextReducer.openDataset(datasetId, outcomeValue)),

  addDataTransform: (datasetId, transform) => dispatch(setupReducer.addDataTransform(datasetId, transform)),
  removeDataTransform: (datasetId, transform) => dispatch(setupReducer.removeDataTransform(datasetId, transform)),

  reindexDataset: (datasetId) => dispatch(uploadReducer.reindexDataset(datasetId)),

  fetchNextDatasets: () => dispatch(homeReducer.fetchNextDatasets()),
  changeDatasetName: (datasetId, name) => dispatch(homeReducer.changeDatasetName(datasetId, name)),

  changeDatasetOutcome: (datasetId, val) => dispatch(homeReducer.changeDatasetTarget(datasetId, val)),

  applyTransformations: (datasetId, val) => dispatch(homeReducer.applyTransformations(datasetId, val)),
  copyAndApplyTransformations: (datasetId, val, name, outcome, outcomeSuccess) =>
    dispatch(homeReducer.copyAndApplyTransformations(datasetId, val, name, outcome, outcomeSuccess)),
  copyAndApplyPlan: (datasetId, name, outcome, outcomeSuccess) =>
    dispatch(homeReducer.copyAndApplyTransformations(datasetId, name, outcome, outcomeSuccess)),
  copyAndChangeDatasetTarget: (datasetId, val, success) =>
    dispatch(homeReducer.copyAndChangeDatasetTarget(datasetId, val, success)),
  copyAndChangeDatasetSuccess: (datasetId, val) => dispatch(homeReducer.copyAndChangeDatasetSuccess(datasetId, val)),

  getSuccessOptions: (dataset, outcome) => homeReducer.getSuccessOptions(undefined, undefined, dataset, outcome),
  getIsOutcomeMulticategorical: (dataset, outcome) =>
    homeReducer.getIsOutcomeMulticategorical(undefined, undefined, dataset, outcome),

  updateDatasetRefreshSchedule: (datasetId, val) =>
    dispatch(setupReducer.updateDatasetRefreshSchedule(`data_${datasetId}`, val)),

  addField: (datasetId, operation, field, extra) =>
    dispatch(transformReducer.addField(datasetId, operation, field, extra)),

  updateDatasetOptions: (datasetId, options) => dispatch(homeReducer.updateDatasetOptions(datasetId, options))
});

const mapStateToProps = (state, ownProps) => {
  const importRecipeId = blueprintReducer.getImportRecipeId(state, ownProps.blueprintId);

  const accounts = accountsReducer.getAccounts(state);
  const selectedFolder = foldersReducer.getSelectedFolder(state);

  const googleSheetsDataset = homeReducer.getGoogleSheetsDataset(state);

  const data = viewReducer.getDatasets(state, ownProps.blueprintId, [googleSheetsDataset]);

  return {
    isTile: viewReducer.getIsTile(state),
    data: data,
    type: ownProps.type ? ownProps.type : viewReducer.getType(state),

    tableauData: loginReducer.getTableauDataOptions(state),
    importRecipeId: blueprintReducer.getImportRecipeId(state, ownProps.blueprintId),
    importVendor: recipeReducer.getImportVendor(state, importRecipeId),
    isImportRecipeExecuting:
      recipeReducer.getRecipeVersionInstanceStatusByBlueprintId(state, ownProps.blueprintId) ==
      recipeReducer.RecipeVersionInstanceStatus.Running,
    isTabUploading: loginReducer.getIsTabUploading(state),
    isDataUploading: globalReducer.getIsDataUploading(state),
    isDatasetsLoading: globalReducer.getIsDatasetsLoading(state),
    useUploadModal: isEnabled("dataset-upload") || (accounts && accounts.length > 1),
    selectedAccountId: accountsReducer.getSelectedAccountId(state),
    account: accountsReducer.getSelectedAccount(state),
    folderEditPermission: foldersReducer.getUserEditPermission(state, selectedFolder),
    folder: foldersReducer.getSelectedFolderData(state),
    tenant: loginReducer.getSelectedTenant(state),
    isSchemaLinkMode: schemaMonitorReducer.getIsShowModal(state),
    isLinkMode: viewReducer.getIsLinkMode(state),

    isTableauMode: globalReducer.getIsTableauMode(state),

    correlations: setupReducer.getCorrelationsFromDataset(state, ownProps.id),

    search: viewReducer.getSearch(state),

    allTransforms: setupReducer.getAllDataTransforms(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SenseViewContainer);
